module.exports = __webpack_public_path__ + "static/trees-3.11-683c37fc6a024f482c3b79224fb98e0c.png";